import {
  CertificationExecutionStatusDto,
  CertificationStageTypeDto,
  StageExecutionStatusDto,
  TestTermParticipantStatusDto,
} from '@/api/generated';

import { CertificationTranslation } from './certification.translation.en';

export const certificationTranslation: CertificationTranslation = {
  card: {
    certificationStatus: {
      [CertificationExecutionStatusDto.Completed]: 'Ukończona',
      [CertificationExecutionStatusDto.InProgress]: 'W trakcie',
      [CertificationExecutionStatusDto.NotStarted]: 'Nierozpoczęta',
    },
    manage: 'Zarządzaj',
    steps: '{{completed}}/{{total}} kroków',
  },
  empty: {
    description: 'Nie masz jeszcze żadnych przypisanych certyfikacji.',
    title: 'Brak przypisanych certyfikacji',
  },
  header: {
    completed: 'Ukończone',
    inProgress: 'W trakcie',
    notStarted: 'Nierozpoczęte',
    sectionTitle: 'Statystyki certyfikacji',
    total: 'Łącznie',
  },
  step: {
    actions: {
      continue: 'Kontynuuj',
      start: 'Rozpocznij',
      viewResults: 'Zobacz wyniki',
    },
    completedAt: 'Ukończono {{date}}',
    completedCount: '{{count}}/{{total}} ukończono',
    deadline: 'Termin {{date}}',
    examAttempt: {
      areasFailed: 'Niezaliczone:',
      areasPassed: 'Zaliczone ({{passed}}/{{total}}):',
      attemptOnDate: 'Próba w dniu {{date}}',
      noAttempts: 'Brak prób egzaminu.',
      openExam: 'Otwórz egzamin',
      result: 'Wynik {{percent}}%',
      status: {
        CANCELLED: 'Anulowany',
        DRAFT: 'Zaplanowany',
        FAILED: 'Niezaliczony',
        PASSED: 'Zaliczony',
        STARTED: 'W trakcie',
      },
      viewResult: 'Zobacz wynik',
    },
    label: 'Krok {{order}}',
    notActive: 'Samoocena nie jest jeszcze aktywna',
    notConfigured: 'Ten krok nie został jeszcze skonfigurowany',
    progress: 'Postęp',
    startedAt: 'Rozpoczęto {{date}}',
    status: {
      [StageExecutionStatusDto.Completed]: 'Ukończony',
      [StageExecutionStatusDto.Expired]: 'Wygasły',
      [StageExecutionStatusDto.InProgress]: 'W trakcie',
      [StageExecutionStatusDto.NotAvailable]: 'Zablokowany',
      [StageExecutionStatusDto.NotInitialized]: 'Nieskonfigurowany',
      [StageExecutionStatusDto.NotStarted]: 'Nierozpoczęty',
    },
    surveyClosed: 'Samoocena zakończona',
    termExpiredInfo: 'Czas minął — ta próba wygasła.',
    termStatus: {
      [TestTermParticipantStatusDto.Assigned]: 'Przypisany',
      [TestTermParticipantStatusDto.Expired]: 'Wygasły',
      [TestTermParticipantStatusDto.Failed]: 'Niezaliczony',
      [TestTermParticipantStatusDto.Passed]: 'Zaliczony',
      [TestTermParticipantStatusDto.Started]: 'Rozpoczęty',
    },
    testWindowOpens: 'Od {{date}} test będzie aktywny.',
    type: {
      [CertificationStageTypeDto.Exam]: 'Test praktyczny',
      [CertificationStageTypeDto.Plan]: 'IPR',
      [CertificationStageTypeDto.Survey]: 'Samoocena',
      [CertificationStageTypeDto.Test]: 'Test teoretyczny',
    },
  },
  title: 'Moje certyfikacje',
};
